import styled from 'styled-components';

export const Wrapper = styled.div`
  line-height: 0.5;
  padding: 20px 0;
  background-color: #554f4d;
  @media (max-width: 768px){
    padding: 20px 0;
  }
  @media (max-width: 480px){
    padding: 20px 0;
  }
`;

export const List = styled.ul`
  display: flex;
  @media (max-width: 480px){
    flex-wrap: wrap;
  }

  li {
    margin: 0 10px 0 10px;
    @media (max-width: 480px){
      padding: 5px 0;

    }
    &:last-child {
      a::after {
        display: none;
      }
    }
  }

  a {
    display: inline-block;
    font-size: 16px;
    color: #fff;
    position: relative;
    line-height: 1.3;
    @media (max-width: 992px){
      font-size: 13px;
    }

    &:hover {
      &::before {
        width: 100%;
      }
    }

    &::before {
      content: '';
      position: absolute;
      bottom: -3px;
      left: 0;
      width: 0;
      height: 2px;
      background-color: #fff;
      transition: width .35s linear;
    }

    &::after {
      content: '/';
      position: absolute;
      top: 0;
      right: -13px;
    }
    &::after {
      @media (max-width: 480px){
        right: -8px;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/system/breadcrumbs/components.js